import React from 'react';
import PropTypes from 'prop-types';
import { Button, FormGroup, Hidden, Paper, Icon } from '@material-ui/core';
import './FormSubsection.css';

const FormSubsection = (props) => {
  return (
    <Paper className="paper-style">
      <FormGroup>
        <div className="subsection-title-wrapper">
          <span className="subsection-title">{props.title}</span>
          <Hidden xsUp={!props.showEdit}>
            <div className="button-wrapper">
              <Button className="edit-button" onClick={props.toggleDisabled}>
                <Icon className="edit-icon">
                  {props.disabled ? 'edit' : 'edit_off'}
                </Icon>
              </Button>
            </div>
          </Hidden>
        </div>
        {props.children}
      </FormGroup>
    </Paper>
  );
};

FormSubsection.propTypes = {
  title: PropTypes.string,
  toggleDisabled: PropTypes.func,
  showEdit: PropTypes.bool
};

export default FormSubsection;
